import {connect} from "react-redux"

// Selectors
import {getMMPerSecond, getMMPerMv} from "../store/selectors"
import {setMMPerMv, setMMPerSecond } from "../store/reducer/SpeedAndAmplitudeReducer";
import { Dispatch } from "redux";
import {RootState} from "../../../models"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    mmPerSecond: getMMPerSecond(state),
    mmPerMv: getMMPerMv(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setMMPerSecond: (value: number) => {
        dispatch(setMMPerSecond(value))
    },
    setMMPerMv: (value: number) => {
        dispatch(setMMPerMv(value))
    },
});

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)

export type WithSpeedAndAmplitudeProps = {
    mmPerSecond: number
    mmPerMv: number
    setMMPerSecond(value: number): void
    setMMPerMv(value: number): void
}
